import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const doppel = defineConnector({
  identifier: "doppel",
  name: "Doppel",
  tagLine: "Brand protection and phishing defense",
  keywords: "impersonation alerts URL scans takedown social engineering",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://api\\.doppel\\.com/v1/.*",
  auth: (app) =>
    headerAuth([
      { name: "x-api-key", value: app.secret.apiKey },
      ...(app.secrets.userApiKey
        ? [{ name: "x-user-api-key", value: app.secret.userApiKey }]
        : []),
      ...(app.configuration.organizationCode
        ? [{ name: "x-organization-code", value: app.config.organizationCode }]
        : []),
    ]),
  steps: [
    {
      title: "Get your V1 API keys",
      items: [
        {
          kind: "markdown",
          content:
            "Contact your Doppel representative for your organization API key. For recommended user-specific access, also generate a user API key in Doppel Vision’s API settings. Requests with both keys use that user’s role and permissions; using only the organization key grants organization-wide access. See [Doppel V1 authentication](https://doppel.readme.io/docs/authentication). This connector uses V1 API keys, not V2 OAuth credentials.",
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "Organization API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
        {
          kind: "input",
          label: "User API key",
          target: { kind: "secrets", field: "userApiKey" },
          helperText:
            "Recommended. Limits requests to the issuing user’s role and permissions. Leave blank only for organization-wide access.",
        },
        {
          kind: "input",
          label: "Organization code",
          target: { kind: "configuration", field: "organizationCode" },
          placeholder: "ACM",
          helperText:
            "Your organization’s three-letter code. Required when the user belongs to multiple organizations; otherwise, leave blank.",
        },
        {
          kind: "markdown",
          content:
            "The connection test reads alerts, so your credentials must have access to alerts. Scans and response actions require the corresponding permissions in Doppel.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://api.doppel.com/v1/alerts?page_size=1",
      method: "GET",
      expectedStatus: 200,
      expectedBodyContains: ['"alerts"', '"metadata"'],
    }),
  },
});
